document.addEventListener("DOMContentLoaded", () => {
  const carrito = JSON.parse(localStorage.getItem('carrito')) || [];
  const totalCantidad = carrito.reduce((acc, item) => acc + item.cantidad, 0);
  const cartCountEl = document.querySelector('.cart-count');
  if(cartCountEl) cartCountEl.textContent = totalCantidad;
});


document.addEventListener("DOMContentLoaded", () => {

  const cartCount = document.querySelector(".cart-count");
  const botones = document.querySelectorAll(".btn-carrito");

  const carritoContainer = document.getElementById('carrito-container');
  const carritoTotalEl = document.getElementById('carrito-total');
  const carritoEnvioEl = document.getElementById('carrito-envio');
  const mensajeEnvioEl = document.getElementById('mensaje-envio');
  const mensajePedidoEl = document.getElementById('mensaje-pedido');

  const regionSelect = document.getElementById('region-select');
  const vaciarBtn = document.getElementById('vaciar-carrito');
  const comprarBtn = document.getElementById('comprar-carrito');

  let carrito = JSON.parse(localStorage.getItem("carrito")) || [];
  const UMBRAL_ENVIO_GRATIS = 500;

  function guardarCarrito(){
    localStorage.setItem("carrito", JSON.stringify(carrito));
  }

  function actualizarContador(){
    if(!cartCount) return;
    const total = carrito.reduce((acc,item)=>acc+item.cantidad,0);
    cartCount.textContent = total;
  }

  function obtenerCantidad(btn){
    const container = btn.closest(".producto-detalle__info") || btn.closest(".card");
    let input = container ? container.querySelector("#cantidad-principal, .cantidad") : null;
    if(!input) return 1;

    let cantidad = parseInt(input.value) || 1;
    if(cantidad < 1) cantidad = 1;

    // Limitar según stock
    const stockMax = parseInt(input.dataset.stock || input.max) || 1;

    // Verificar cantidad ya agregada en carrito
    const productoId = btn.dataset.id;
    const existe = carrito.find(p => p.id === productoId);
    const cantidadExistente = existe ? existe.cantidad : 0;

    if(cantidad + cantidadExistente > stockMax){
      cantidad = stockMax - cantidadExistente;
      if(cantidad <= 0){
        alert(`Ya alcanzaste el límite disponible (${stockMax} unidades) de este producto`);
        return 0;
      }
      alert(`Solo hay ${stockMax} unidades disponibles. Se agregará la cantidad máxima posible`);
    }

    return cantidad;
  }

  function agregarProducto(btn){

    const cantidad = obtenerCantidad(btn);

    const producto = {
      id: btn.dataset.id,
      nombre: btn.dataset.nombre,
      precio: parseFloat(btn.dataset.precio),
      cantidad: cantidad
    };

    const existe = carrito.find(p => p.id === producto.id);

    if(existe){
      existe.cantidad += producto.cantidad;
    }else{
      carrito.push(producto);
    }

    guardarCarrito();
    actualizarContador();
    mostrarCarrito();
  }

  botones.forEach(btn=>{
    btn.addEventListener("click", ()=> agregarProducto(btn));
  });

  function mostrarCarrito(){

    if(!carritoContainer) return;

    carritoContainer.innerHTML = '';

    if(carrito.length === 0){
      carritoContainer.innerHTML = '<p>Tu carrito está vacío.</p>';
      carritoTotalEl.textContent = 'Total: $0.00';
      carritoEnvioEl.textContent = 'Envío: $0.00';
      mensajeEnvioEl.textContent = '';
      return;
    }

    let subtotal = 0;

    carrito.forEach(item=>{

      const subtotalItem = item.precio * item.cantidad;
      subtotal += subtotalItem;

      const div = document.createElement('div');

      div.style.display='flex';
      div.style.justifyContent='space-between';
      div.style.alignItems='center';
      div.style.marginBottom='1rem';
      div.style.padding='0.5rem';
      div.style.borderBottom='1px solid #444';

      div.innerHTML = `
        <div>
          <strong>${item.nombre}</strong><br>
          $${item.precio.toFixed(2)} x ${item.cantidad} = $${subtotalItem.toFixed(2)}
        </div>
        <button class="btn-carrito btn-eliminar" data-id="${item.id}">Eliminar</button>
      `;

      div.querySelector('.btn-eliminar').addEventListener('click', ()=>{

        carrito = carrito.filter(p=>p.id !== item.id);

        guardarCarrito();
        actualizarContador();
        mostrarCarrito();

      });

      carritoContainer.appendChild(div);

    });

    actualizarEnvio(subtotal);
  }

  function actualizarEnvio(subtotal){

    if(!regionSelect) return;

    let envio = parseFloat(regionSelect.selectedOptions[0].dataset.envio);

    if(subtotal >= UMBRAL_ENVIO_GRATIS){
      envio = 0;
      mensajeEnvioEl.textContent = '¡Superaste el monto mínimo! Envío gratis.';
    }else{
      mensajeEnvioEl.textContent = '';
    }

    carritoEnvioEl.textContent = `Envío: $${envio.toFixed(2)}`;
    carritoTotalEl.textContent = `Total: $${(subtotal + envio).toFixed(2)}`;
  }

  if(regionSelect){
    regionSelect.addEventListener('change', mostrarCarrito);
  }

  if(vaciarBtn){
    vaciarBtn.addEventListener('click', ()=>{

      carrito = [];
      guardarCarrito();
      actualizarContador();
      mostrarCarrito();

      if(mensajePedidoEl) mensajePedidoEl.textContent='';

    });
  }

  if(comprarBtn){

    comprarBtn.addEventListener('click', ()=>{

      if(carrito.length === 0){
        alert('El carrito está vacío');
        return;
      }

      const nombre = document.getElementById('nombre').value.trim();
      const apellido = document.getElementById('apellido').value.trim();
      const direccion = document.getElementById('direccion').value.trim();
      const telefono = document.getElementById('telefono').value.trim();

      if(!nombre || !apellido || !direccion || !telefono){
        alert('Por favor completa todos los datos.');
        return;
      }

      const numeroOrden = Math.floor(Math.random()*90000)+10000;

      mensajePedidoEl.innerHTML =
      `Gracias por tu visita, tu número de pedido es <strong>${numeroOrden}</strong>.<br>
      Pronto un agente te escribirá por WhatsApp.`;


      let subtotal = carrito.reduce((acc,i)=>acc+i.precio*i.cantidad,0);
      let envio = parseFloat(regionSelect.selectedOptions[0].dataset.envio);

      if(subtotal >= UMBRAL_ENVIO_GRATIS) envio = 0;

      let mensaje = `🛒 *Resumen del pedido*%0A%0A`;

      carrito.forEach((item,index)=>{
        mensaje += `${index+1}. ${item.nombre} x${item.cantidad} - $${(item.precio*item.cantidad).toFixed(2)}%0A`;
      });

      mensaje += `%0A*Subtotal:* $${subtotal.toFixed(2)}%0A`;
      mensaje += `*Envío:* $${envio.toFixed(2)}%0A`;
      mensaje += `*Total:* $${(subtotal+envio).toFixed(2)}%0A%0A`;

      mensaje += `*Número de orden:* ${numeroOrden}%0A`;
      mensaje += `*Cliente:* ${nombre} ${apellido}%0A`;
      mensaje += `*Dirección:* ${direccion}%0A`;
      mensaje += `*Teléfono:* ${telefono}%0A`;

      const telefonoAsesor = '521234567890';

      window.open(`https://wa.me/${telefonoAsesor}?text=${mensaje}`, '_blank');

    });

  }

  actualizarContador();
  mostrarCarrito();

});